import Promise from 'es6-promise'
Promise.polyfill();
import axios from 'axios'
import store from './store/index'

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(function(config){
	var token = store.state.oidcStore.access_token;
	if(token){
		config.headers["Authorization"]="Bearer "+token;
	}
	return config;
},function(error){
	console.log(error);
	return Promise.reject(error);
});

// //返回状态判断(添加响应拦截器)
// axios.interceptors.response.use(function(res){
//     //对响应数据做些事
//     if(!res.data.success){
//         return Promise.resolve(res);
//     }
//     return res;
// }, function(error){
//     console.log('网络异常')
//     return Promise.reject(error);
// });

//在main.js设置全局的请求次数，请求的间隙
axios.defaults.retry = 4;
axios.defaults.retryDelay = 1000;

axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
    var config = err.config;
    // If config does not exist or the retry option is not set, reject
    if(!config || !config.retry) return Promise.reject(err);
    
    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0;
    
    // Check if we've maxed out the total number of retries
    if(config.__retryCount >= config.retry) {
        // Reject with the error
        return Promise.reject(err);
    }
    
    // Increase the retry count
    config.__retryCount += 1;
    
    // Create new promise to handle exponential backoff
    var backoff = new Promise(function(resolve) {
        setTimeout(function() {
            resolve();
        }, config.retryDelay || 1);
    });
    
    // Return the promise in which recalls axios to retry the request
    return backoff.then(function() {
        return axios(config);
    });
});

export default axios;


// WEBPACK FOOTER //
// ./src/axiosConfig.js